import { TextPanel } from './DetailPanel';

interface RunDetailsProps {
  promptUsed: string;
  transcript: string;
}

/**
 * Seeing the exact prompt and transcript the models received is what makes a
 * surprising result diagnosable — the old page exposed both and losing them would
 * make the comparison unauditable.
 */
export const RunDetails = ({ promptUsed, transcript }: RunDetailsProps) => (
  <div className="space-y-2">
    <TextPanel label="Kerfisboð sem var notað" body={promptUsed} />
    <TextPanel label="Umritun" body={transcript} />
  </div>
);
